export class ActivityLogConstants {
	static readonly FRIENDLY_NAME = "Activity Log";
}
